import { useEffect } from "react";
import { Userpilot } from "userpilot";

import { PageProvider } from "@providers/PageProvider";

import XToken from "@container/pages/XToken";

import Sidebar from "@components/Sidebar";
import Header from "@components/Header";
import PageLayout from "@components/PageLayout";
import stakeData from "@constants/stake_cms.json";
import PageHead from "@components/PageHead/PageHead";
import { useDappSDKProvider } from "dapp-sdk-v2";

interface PageProps {
  page: any;
  isSafeMode: boolean;
}

const LiquidStakingPage = ({ page, isSafeMode }: PageProps) => {
  const {
    firebaseEventsData,
    walletAddress,
    tokenAmount,
    isBannerVisible,
    setStakeData,
  } = useDappSDKProvider();

  const setMobileMenuVisible = (isVisible: boolean) => {
    setStakeData({
      isMobileMenuOpen: isVisible,
    });
  };

  useEffect(() => {
    if (walletAddress) {
      if ((window as any).userpilotSettings.userid !== walletAddress) {
        Userpilot.identify(walletAddress, {
          ...firebaseEventsData,
        });
      }
    } else {
      Userpilot.anonymous();
    }
  }, [walletAddress, tokenAmount]);

  return (
    <PageHead page="stake">
      <PageProvider page={page} isSafeMode={isSafeMode}>
        <PageLayout
          Sidebar={
            <Sidebar
              display={{ base: "none", xl: "block" }}
              minH={{
                base: "100vh",
                xl: isBannerVisible ? "calc(100vh - 32px)" : "100vh",
              }}
            />
          }
          MobileSideBar={
            <Sidebar setMobileMenuVisible={setMobileMenuVisible} />
          }
          Header={<Header />}
        >
          <XToken />
        </PageLayout>
      </PageProvider>
    </PageHead>
  );
};

export async function getStaticProps() {
  return {
    props: {
      page: {
        data: {
          ...stakeData,
        },
        error: null,
      },
    },
  };
}

export default LiquidStakingPage;
